import { storageHelper, Storages } from '@spo/logic';
import { useState } from 'react';

type UseSessionStateReturn<T> = [T, (value: T) => void];

function useSessionState<T>(
  key: string,
  defaultValue: T,
): UseSessionStateReturn<T> {
  const [state, setState] = useState<T>(() => {
    const sessionValue = storageHelper.getItem<string>(key, Storages.session);
    return sessionValue ? (JSON.parse(sessionValue) as T) : defaultValue;
  });

  const setSessionState = (value: T) => {
    setState(value);
    storageHelper.setItem(key, JSON.stringify(value), Storages.session);
  };
  return [state, setSessionState];
}

export default useSessionState;
